import { Injectable } from '@angular/core';
import { MktContentStorageService } from './mkt-content-storage.service';

interface CardInfo {
  pid: number,
  cardName: string,
  ariaLabel?: string,
  internalCardName?: string,
  imageUrl?: URL,
  pdpUrl: URL
}

@Injectable()
export class MktCardRetrievalService {
  private cards: any = [];
  allCardContent: any;

  constructor(
    private _mktContentStorageService: MktContentStorageService
  ) {
      this.commonOnInit();
      // Make sure the cards are loaded all the time
      const instance = setInterval(() => {
        (this.cards.length > 0) ? clearInterval(instance) : this.commonOnInit();      
      }, 1000);
    }

  private commonOnInit() {
    const cardArtContent = this._mktContentStorageService.get('Branding', 'copy', 'cardArt_refresh', undefined);
    if(!cardArtContent) return;
    this.allCardContent = JSON.parse(cardArtContent.TEXT) || {};
    const availableCards = this.allCardContent.cards || [];

    // Get all cards
    this.cards = availableCards
      .map(({internalCardName, pid, cardName, pdpPageLink}) => {

        // Return the card object
        return <CardInfo>{
          pid,
          cardName,
          internalCardName,
          pdpUrl: pdpPageLink,
        };
      })
      .filter(card => !!card); // Filter out none cards
  }

  public getCardByPid(pid: number | string = undefined): CardInfo {
    //if (!(+pid)) return; // Return when not a valid number
    if (!pid) return;
    const card = this.cards.filter(card => pid == card.pid)[0];
    return card ? { ...card } : undefined;
  }

  public getCardByName(internalCardName: string = undefined): CardInfo {
    if (!internalCardName) return; // Return when not a valid string

    const card = this.cards.filter(card => internalCardName.toLocaleLowerCase() == (card.internalCardName || '').toLocaleLowerCase())[0];
    return card ? { ...card } : undefined;
  }
}
